import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from '@mui/material';
import get from 'lodash/get';

import AppCenterButtons from './app-center-buttons';
import wranglerActions from '../../../actions/wranglers';
import * as snackbarActions from '../../../actions/snackbar';

class AppCenterButtonsContainer extends Component {
  handleAddToIOS = () => {
    const {
      createUserIOS,
      showSuccessSnackbar,
      showErrorSnackbar,
      emails,
      onClick,
    } = this.props;
    createUserIOS(emails)
      .then(({ data }) => {
        const { successes, fails } = data;
        const successString = successes.length > 2 ? `${successes.length} emails` : successes.join(', ');
        const failsString = fails.length > 2 ? `${fails.length} emails failed.` : `${fails.join(', ')} failed.`;
        let successStringFinal = `Successfully added ${successString} to IOS Group.`;
        if (fails.length) successStringFinal += failsString;
        showSuccessSnackbar(successStringFinal);
        onClick();
      })
      .catch((error) => {
        const errMsg = get(error, 'response.data', 'Error adding user to IOS list');
        showErrorSnackbar(errMsg);
      });
  }

  handleDeleteIOS = () => {
    const {
      deleteUserIOS,
      showSuccessSnackbar,
      showErrorSnackbar,
      emails,
      onClick,
    } = this.props;
    deleteUserIOS(emails)
      .then(() => {
        showSuccessSnackbar('Deleted email(s) from IOS Group.');
        onClick();
      })
      .catch((error) => {
        const errMsg = get(error, 'response.data', 'Error removing from IOS');
        showErrorSnackbar(errMsg);
      });
  }

  render() {
    const {
      showIOSAdd,
      showIOSEdit,
    } = this.props;
    return (
      <Grid container>
        <AppCenterButtons
          onAddToIOS={this.handleAddToIOS}
          onDeleteIOS={this.handleDeleteIOS}
          showIOSAdd={showIOSAdd}
          showIOSEdit={showIOSEdit}
        />
      </Grid>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...wranglerActions,
  ...snackbarActions,
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppCenterButtonsContainer));
